import {gql} from "@apollo/client/core";
import {ShareableFragment} from "./shareable-fragment";

export const ShopSessionsFragment = gql`
    fragment ShopSessionsFragment on ShopSession {
        shopSessionId
        shortUrlId
        referer
        ipAddress
        userAgent
        createDate
        longUrl
        locale
        shareable {
            ...ShareableFragment
        }
        shopSessionEvents {
            shopSessionEventId
            sponsorId
            retailId
            customerId
            orderId
            eventCategory
            eventType
            eventData1
            eventData2
            createDate
        }
    }
    ${ShareableFragment}
`;
